import type { ChangelogEntry } from "../types";

/** 16 funksjonsbrytere fjernet (15 alltid på, én funksjon fjernet), tre admin-brytere flyttet til Systemroller. */
export const FUNKSJONSBRYTERE_RYDDET_2026_10: ChangelogEntry = {
  id: "2026-10-27-funksjonsbrytere-ryddet",
  date: "2026-10-27",
  title: "Færre funksjonsbrytere",
  summary:
    "Femten funksjoner som var testet ferdig, er nå på for alle, og bryterne deres er borte fra Innstillinger → Drift. Redigering av føringer fra budsjettet er fjernet. Tre brytere som egentlig handlet om hvem som har tilgang, styres nå i Systemroller.",
  sections: [
    {
      heading: "Innstillinger",
      items: [
        {
          title: "Reell timepris og statistlønn styres i Systemroller",
          kind: "forbedret",
          body: "«Reell timepris per selger», «Reell timepris per prosjektleder» og «Statistlønn (CSV-eksport)» er nye rader i Systemroller. De er på for admin og superadmin, som før.",
        },
        {
          title: "Bryterne for ferdigtestede funksjoner er fjernet",
          kind: "forbedret",
          body: "Gjelder tilbud-UX, popupen for Nytt i Revehiet, fraværsflyten, varsel om manglende timer, prosjektoppdateringer i popup, åpne behandlede oppgaver, husk kollapsede seksjoner, slide-loopen på salgsdisplayet, full prosjektrapport, og alt i utrullingen «Små forbedringer i timeføring og på prosjektene».",
        },
      ],
    },
    {
      heading: "Budsjett og feedback",
      items: [
        {
          title: "Føringer kan ikke lenger rettes fra budsjettet",
          kind: "forbedret",
          body: "Listen bak «Brukt»-tallet viser føringene, men de rettes fra Timer som før.",
        },
        {
          title: "«Kosmetisk eller forslag» heter nå «Kosmetisk»",
          kind: "forbedret",
          body: "Gjelder prioritetsvalget i feedback-skjemaet, i feedback-oversikten og i Slack. Teksten om hvem beskjeden lagres for er fjernet fra dialogen.",
        },
      ],
    },
  ],
};
